import { render, staticRenderFns } from "./OutliersBoxPlot.vue?vue&type=template&id=2da93fa6"
import script from "./OutliersBoxPlot.vue?vue&type=script&lang=js"
export * from "./OutliersBoxPlot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports